import { AdminTeams } from '@platform/client';
import { useContext } from 'react';
import { AdminTableContext } from '../../../AdminTable';
import { useQueryClient } from '@tanstack/react-query';
import { Modal } from '@platform/components';

export const ApproveTeamModal = ({
  teamIds,
  cohortId,
  isOpen,
  onClose,
}: {
  teamIds: number[];
  cohortId: number;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const approveTeamMutator = AdminTeams.useApproveTeam({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetFreeAgentsQueryKey({
            cohort_id: cohortId,
            page: adminQueryOptionsV2.page,
            limit: adminQueryOptionsV2.limit,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: AdminTeams.getGetTeamsCountsQueryKey({
            cohort_id: cohortId,
          }),
        });
        for (const teamId of teamIds) {
          queryClient.invalidateQueries({
            queryKey: AdminTeams.getGetTeamDetailsQueryKey({ team_id: teamId }),
          });
        }
        onClose();
      },
    },
  });
  return (
    <Modal
      variant='dialog'
      isOpen={isOpen}
      onClose={onClose}
      title='Approve Team'
      headerDivision='divider'
      primaryCTA={{
        text: 'Approve',
        callback: () => {
          approveTeamMutator.mutate({ data: teamIds });
        },
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: onClose,
      }}
      ignoreExtraPadding
    >
      <div>
        Approve team{teamIds.length > 1 ? 's' : ''} #{teamIds.join(', ')}?
      </div>
    </Modal>
  );
};
